export interface LoadingDotsProps {
  /** Duration of opacity transition in ms */
  transitionDuration?: number
  /** Whether the dots are visible */
  isVisible?: boolean
  /** Additional CSS classes */
  className?: string
}

/**
 * Animated loading dots indicator.
 * Shows three dots with a wave animation.
 * 
 * @example
 * <LoadingDots isVisible={isLoading} />
 */
export function LoadingDots({
  transitionDuration = 300,
  isVisible = true,
  className = '',
}: LoadingDotsProps) {
  return (
    <div
      className={`flex gap-1 justify-center items-center ${className}`}
      style={{
        opacity: isVisible ? 1 : 0,
        transition: `opacity ${transitionDuration}ms ease-in-out`,
      }}
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="w-2 h-2 bg-gray-600 rounded-full"
          style={{
            animation: 'revel8-loading-dots-wave 1.2s infinite ease-in-out',
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
      <style>{`
        @keyframes revel8-loading-dots-wave {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-6px);
          }
        }
      `}</style>
    </div>
  )
}

export default LoadingDots

